// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#home-main-imgctr {
	width: 100%;

	overflow: hidden;
}

#home-main-imgctr img {
	width: 100%;
	height: 100%;

	object-fit: cover;
	object-position: center;
	display: block;
}

#home-main-textctr {
	padding-left: 30px;
	padding-right: 30px;
	padding-bottom: 40px;

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
}

#home-main-header {
	margin-top: 30px;
	margin-bottom: 0px;

	font-size: var(--header-font-size);
	text-align: center;
}

#home-main-bodytext {
	font-size: var(--body-normal-size);
	text-align: left;
}




@media (min-width: 1021px) {
	#home-main-imgctr img {
		height: 600px;
	}
}

@media (min-width: 751px) and (max-width: 1020px) {
	#home-main-imgctr img {
		height: 400px;
	}
}

@media (min-width: 451px) and (max-width: 750px) {
	#home-main-imgctr img {
		min-height: 230px;
		max-height: 350px;
	}
}

@media (max-width: 450px) {
	#home-main-imgctr img {
		min-height: 160px;
		max-height: 230px;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAAA;CACC,WAAW;;CAEX,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;;CAEZ,iBAAiB;CACjB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;;CAEpB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;;CAElB,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;AACjB;;;;;AAKA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,iBAAiB;CAClB;AACD","sourcesContent":["#home-main-imgctr {\n\twidth: 100%;\n\n\toverflow: hidden;\n}\n\n#home-main-imgctr img {\n\twidth: 100%;\n\theight: 100%;\n\n\tobject-fit: cover;\n\tobject-position: center;\n\tdisplay: block;\n}\n\n#home-main-textctr {\n\tpadding-left: 30px;\n\tpadding-right: 30px;\n\tpadding-bottom: 40px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 20px;\n}\n\n#home-main-header {\n\tmargin-top: 30px;\n\tmargin-bottom: 0px;\n\n\tfont-size: var(--header-font-size);\n\ttext-align: center;\n}\n\n#home-main-bodytext {\n\tfont-size: var(--body-normal-size);\n\ttext-align: left;\n}\n\n\n\n\n@media (min-width: 1021px) {\n\t#home-main-imgctr img {\n\t\theight: 600px;\n\t}\n}\n\n@media (min-width: 751px) and (max-width: 1020px) {\n\t#home-main-imgctr img {\n\t\theight: 400px;\n\t}\n}\n\n@media (min-width: 451px) and (max-width: 750px) {\n\t#home-main-imgctr img {\n\t\tmin-height: 230px;\n\t\tmax-height: 350px;\n\t}\n}\n\n@media (max-width: 450px) {\n\t#home-main-imgctr img {\n\t\tmin-height: 160px;\n\t\tmax-height: 230px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
